import { render } from "./UploadMultFilesWithPrimeVue.vue?vue&type=template&id=ecf27374"
import script from "./UploadMultFilesWithPrimeVue.vue?vue&type=script&lang=js"
export * from "./UploadMultFilesWithPrimeVue.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__